export const server = "https://api.meblim.com/api/v2";


